var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$helper.ofisSuresiDoldu())?_c('v-col',{staticClass:"py-1",attrs:{"cols":"12"}},[_c('v-alert',{staticClass:"mb-0",attrs:{"type":"warning","border":"left","dense":"","text":""}},[_vm._v(" 3 ay sonra tüm alanlar engellenecektir. ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }